/**
 * A tela do link de uso único que o assistente da Arbitragem manda no chat (MCP, 20q D9): abre sem
 * login e com qualquer sessão, porque o token do link é a credencial. Os desvios de sessão (portal,
 * item compartilhado, árbitro) a deixam passar: redirecionar antes da troca perderia o envio.
 */
const TELA_DO_ENVIO_ARBITRAL = '/arbitral/envio';

/** A tela do envio ou uma subrota dela. */
export const ehTelaDoEnvioArbitral = (pathname: string): boolean =>
  pathname === TELA_DO_ENVIO_ARBITRAL || pathname.startsWith(`${TELA_DO_ENVIO_ARBITRAL}/`);

const publicRoutePrefixes = [
  '/login',
  '/cadastro',
  '/convite',
  '/convite-compartilhado',
  '/convite-advogado',
  '/convite-arbitro',
  '/compartilhado/login',
  '/verificar-email',
  '/auth',
  '/onboarding',
  '/termos-de-uso',
  '/politica-de-privacidade',
  '/notificacoes/certificado',
  '/autenticar',
  '/ativar',
  '/portal',
  '/negociacao-self',
  '/notificacao-self',
  '/onboarding-self',
  '/api/pdf/renderUrlPdf',
  '/api/pdf/download',
  TELA_DO_ENVIO_ARBITRAL,
] as const;

export const isPublicPath = (pathname: string): boolean => {
  return publicRoutePrefixes.some((route) => {
    return pathname === route || pathname.startsWith(`${route}/`);
  });
};
